import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { gql } from '../../graphql/generated/gql';
import parseExternalPostId from '../../utils/parseExternalPostId';
import postPath from '../../utils/url/postPath';
import useIsPublicView from '../../utils/useIsPublicView';
import MentionBase from './MentionBase';

const EXTERNAL_POST_MENTION_QUERY = gql(/** @complexity 1 */ `
  query externalPostMention($platform: String!, $externalId: ID!) {
    post: externalPost(platform: $platform, externalId: $externalId) {
      id
      title
    }
  }
`);

interface ExternalPostMentionProps {
  id: string;
  content?: string | null;
  mentionText?: string | null;
  updateCache?: (title: string) => void;
  link?: boolean;
  selected?: boolean;
}

const ExternalPostMention = ({
  id,
  content = '',
  mentionText = '',
  updateCache,
  link,
  selected,
}: ExternalPostMentionProps) => {
  const isPublicView = useIsPublicView();
  const { externalId, platform, anchor } = parseExternalPostId(id) ?? {};
  const { data } = useQuery(EXTERNAL_POST_MENTION_QUERY, {
    variables: {
      // @ts-expect-error
      externalId,
      // @ts-expect-error
      platform,
    },
  });

  const post = data?.post ? data.post : null;

  useEffect(() => {
    if (!isPublicView && post) {
      updateCache?.(post.title);
    }
  }, [updateCache, isPublicView, post]);

  return (
    <MentionBase
      type="external"
      to={link && post ? postPath(post, { anchor }) : undefined}
      content={mentionText || post?.title || content || externalId}
      selected={selected}
    />
  );
};

export default ExternalPostMention;
